// in the event that fetching the timeline years fails, we will default to this list
export const getFallbackPastYears = () => {
  const result = [];
  const currentYear = new Date().getFullYear();

  for (let i = currentYear; i >= 1985; i -= 1) {
    result.push(i.toString());
  }

  return result;
};

export const fallbackPastYears = getFallbackPastYears();
